module.exports = __webpack_public_path__ + "media/images/athletes/2194-a8af8e94108cf0f8db53da98f33284f4.png";